/* ===========================
   MIXPANEL PRODUCT TRACKING
   (Clean & Final Production)
============================ */



// Register review photos A/B variant as a super property so it is
// automatically attached to every subsequent mixpanel.track() call,
// including Add to Cart and Checkout Start.
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    try {
      if (window.SLAY_AB_REVIEW) {
        mixpanel.register({ ab_review_variant: window.SLAY_AB_REVIEW.variant });
      }
    } catch (e) {}
  });
})();

(function () {
  document.addEventListener('click', function (e) {
    const el = e.target.closest('#myDiv');

    if (el) {
      mixpanel.track('Size Guide Opened', {
        ab_variant: window.SLAY_AB ? window.SLAY_AB.variant : 'unknown'
      });
    }
  });
})();

// 3. REVIEWS EXPANDED
(function () {
  document.addEventListener('click', function (e) {
    if (e.target.innerText && e.target.innerText.includes('Read more')) {
      var reviewVariant = 'A';
      try { reviewVariant = localStorage.getItem('slay_ab_review_photos') || 'A'; } catch(err) {}
      mixpanel.track('Reviews Expanded', {
        ab_review_variant: reviewVariant
      });
    }
  });
})();



(function () {
  const errorMessage = document.querySelector('.product-form__error-message');
  if (!errorMessage) return;

  const observer = new MutationObserver(function () {
    if (errorMessage.classList.contains('active')) {
      mixpanel.track('size-popup opened', {
        product_id: window.SLAY_PRODUCT_CONTEXT?.product_id || '',
        product_name: window.SLAY_PRODUCT_CONTEXT?.product_title || '',
        ab_variant: window.SLAY_AB?.variant || 'unknown'
      });
    }
  });

  observer.observe(errorMessage, {
    attributes: true,
    attributeFilter: ['class']
  });
})();



// 4. IMAGE MODAL OPEN
(function () {
  document.addEventListener('click', function (e) {
    if (e.target.innerText && e.target.innerText.includes('Open media')) {
      mixpanel.track('Image Opened');
    }
  });
})();

// 5. PAGE EXIT (CLEAN VERSION)
(function () {
  const startTime = Date.now();

  window.addEventListener('pagehide', function () {
    mixpanel.track('Page Exit', {
      time_on_page_seconds: Math.round((Date.now() - startTime) / 1000)
    });
  });
})();

// 6. IMAGE VIEW TIME TRACKING
(function () {
  if (!window.IntersectionObserver) return;

  // Expose state map for debugging: window._slayImageTracking
  const stateMap = {};
  window._slayImageTracking = stateMap;

  const THRESHOLD = 0.6;

  // EXIT_DEBOUNCE_MS: wait this long after an exit before treating it as real.
  // Prevents content-visibility:auto layout shifts from causing false exits.
  const EXIT_DEBOUNCE_MS = 300;

  // FLUSH_MIN_AGE_MS: ignore page-exit flushes that fire within this many ms
  // of page load — catches mobile browsers' spurious visibilitychange:hidden
  // on initial page load.
  const FLUSH_MIN_AGE_MS = 500;

  const pageLoadTime = performance.now();

  const productCtx = window.SLAY_PRODUCT_CONTEXT || {};

  // Scope to ONLY the product gallery slider — avoids picking up slides from
  // Featured Collection, Related Products, or any other carousel on the page
  // that also uses the "Slide-" id prefix.
  // We look for slider-component[id^="GalleryViewer-"] because SLAY_PRODUCT_CONTEXT
  // does not expose section_id — no Liquid change needed.
  const galleryViewer = document.querySelector('slider-component[id^="GalleryViewer-"]');
  const slideRoot = galleryViewer || document;
  const slides = slideRoot.querySelectorAll('li[id^="Slide-"]:not([id^="Slide-Thumbnails-"])');
  if (!slides.length) return;

  /**
   * Fire a Mixpanel "Image View" event for the given slide state.
   * Uses navigator.sendBeacon when useBeacon is true (page exit path).
   */
  function fireEvent(state, useBeacon) {
    const sessions = state.sessions;
    const props = {
      slide_id: state.slideId,
      media_id: state.mediaId,
      position: state.position,
      product_title: productCtx.product_title || null,
      total_duration_sec: parseFloat((state.totalMs / 1000).toFixed(3)),
      view_count: state.viewCount,
      // Use sessions.length guard (not truthy check) so 0ms is still reported
      first_view_duration_sec: sessions.length >= 1
        ? parseFloat((sessions[0] / 1000).toFixed(3))
        : null,
      second_time_duration_sec: sessions.length >= 2
        ? parseFloat((sessions[1] / 1000).toFixed(3))
        : null,
      click_count: state.clickCount,
      double_click_count: state.dblClickCount,
      ab_variant: window.SLAY_AB ? window.SLAY_AB.variant : (window.__SLAY_AB_VARIANT || 'unknown'),
      ab_review_variant: window.SLAY_AB_REVIEW ? window.SLAY_AB_REVIEW.variant : (window.__SLAY_AB_REVIEW_VARIANT || 'unknown'),
    };

    if (useBeacon && navigator.sendBeacon) {
      try {
        const payload = {
          event: 'Image View',
          properties: Object.assign({}, props, {
            token: mixpanel.get_property('$token') || (mixpanel.config && mixpanel.config.token),
            distinct_id: mixpanel.get_distinct_id ? mixpanel.get_distinct_id() : undefined,
          }),
        };
        navigator.sendBeacon(
          'https://api.mixpanel.com/track?ip=1',
          new Blob([JSON.stringify([payload])], { type: 'text/plain' })
        );
      } catch (err) {
        mixpanel.track('Image View', props);
      }
    } else {
      mixpanel.track('Image View', props);
    }
  }

  /**
   * Commit a finalised exit: push session, update totals, fire event.
   * Only called after the debounce timer confirms the exit is real.
   */
  function commitExit(state, exitTime) {
    if (state.enterTime === null) return; // entry was re-triggered during debounce
    const sessionMs = exitTime - state.enterTime;
    state.sessions.push(sessionMs);
    state.totalMs += sessionMs;
    state.enterTime = null;
    fireEvent(state, false);
  }

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      const state = stateMap[entry.target.id];
      if (!state) return;
      const now = performance.now();

      if (entry.isIntersecting) {
        // Cancel any pending debounced exit — element came back into view
        if (state.exitTimer) {
          clearTimeout(state.exitTimer);
          state.exitTimer = null;
        }

        // Only start a new session if we aren't already tracking one
        if (state.enterTime === null) {
          state.viewCount += 1;
          state.enterTime = now;
        }
      } else {
        // Debounce the exit: wait EXIT_DEBOUNCE_MS before treating as real.
        // This absorbs content-visibility:auto layout jitter.
        if (state.enterTime !== null && !state.exitTimer) {
          const capturedExitTime = now;
          state.exitTimer = setTimeout(function () {
            state.exitTimer = null;
            commitExit(state, capturedExitTime);
          }, EXIT_DEBOUNCE_MS);
        }
      }
    });
  }, {
    threshold: THRESHOLD,
  });

  // Initialise per-slide state and observe
  slides.forEach(function (el, idx) {
    const slideId = el.id;
    const mediaId = el.dataset.mediaId || slideId;

    stateMap[slideId] = {
      slideId: slideId,
      mediaId: mediaId,
      position: idx + 1,
      viewCount: 0,
      totalMs: 0,
      enterTime: null,
      exitTimer: null,
      sessions: [],
      clickCount: 0,
      dblClickCount: 0,
    };

    observer.observe(el);
  });

  // Click / double-click tracking via event delegation on the slide list.
  // dblclick fires AFTER two click events, so click_count already includes
  // the two clicks that made up the double-click — which is the correct
  // cumulative count of all taps.
  function findSlideEl(target) {
    return target.closest('li[id^="Slide-"]');
  }

  var slideList = slides[0] && slides[0].parentElement;
  if (slideList) {
    slideList.addEventListener('click', function (e) {
      var li = findSlideEl(e.target);
      if (li && stateMap[li.id]) stateMap[li.id].clickCount += 1;
    });

    slideList.addEventListener('dblclick', function (e) {
      var li = findSlideEl(e.target);
      if (li && stateMap[li.id]) stateMap[li.id].dblClickCount += 1;
    });
  }

  /**
   * Flush any in-progress view when the user leaves the page.
   * Guarded by FLUSH_MIN_AGE_MS to ignore spurious mobile page-load events.
   */
  function flushOnExit() {
    if (performance.now() - pageLoadTime < FLUSH_MIN_AGE_MS) return;

    const now = performance.now();
    Object.values(stateMap).forEach(function (state) {
      // Cancel any pending debounce — we're exiting for real
      if (state.exitTimer) {
        clearTimeout(state.exitTimer);
        state.exitTimer = null;
      }
      if (state.enterTime !== null) {
        const sessionMs = now - state.enterTime;
        state.sessions.push(sessionMs);
        state.totalMs += sessionMs;
        state.enterTime = null;
        fireEvent(state, true /* useBeacon */);
      }
    });
  }

  window.addEventListener('pagehide', flushOnExit);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      flushOnExit();
    }
  });
})();
